<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="list"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök kodtyper</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import { sortLabelByAZ } from '@services/Helpers';
import CodeTypesRepository from '@services/repositories/Product/CodeTypesRepository';

export default {
    components: {
        VueSelect,
    },
    data() {
        return {
            list: [],
        };
    },
    async created() {
        const repo = new CodeTypesRepository();
        const result = await repo.setPerPage(1000).run();

        this.list = result.data.map((item) => ({
            label: item.ProductCodeTypeName || item.name,
            id: item.ProductCodeTypeID || item.id,
            ...item,
        })).sort(sortLabelByAZ);
    },
};
</script>
